import { FC, useState } from 'react';
import styled from 'styled-components';
import { Badge, Button, Stack, Typography } from '@mui/material';
import { Check } from '@mui/icons-material';
import {
  VsTransferEvent,
  useGetHeroConversationById,
} from '@vs-online-only-app/state';
import { UserAvatar } from '@vs-online-only-app/ui';
import { RootTransferCard } from './OutgoingTransferCard';

const CheckCircle = styled.div`
  display: grid;
  place-content: center;
  width: ${({ theme }) => theme.spacing(3)};
  height: ${({ theme }) => theme.spacing(3)};
  background: ${({ theme }) => theme.palette.success.main};
  border-radius: ${({ theme }) => theme.spacing(2)};
`;

type Props = {
  event: VsTransferEvent;
  onClose: () => void;
  slideIn?: boolean;
};

export const AcceptedTransferCard: FC<Props> = ({
  event,
  onClose,
  slideIn,
}) => {
  const [isVisible, setIsVisible] = useState<boolean>(true);
  const { data: conversation } = useGetHeroConversationById(event.conversation);

  if (!conversation || !isVisible) {
    return null;
  }

  return (
    <RootTransferCard $slideIn={slideIn} elevation={1}>
      <Badge
        overlap="circular"
        badgeContent={
          <CheckCircle>
            <Check fontSize="small" />
          </CheckCircle>
        }
        sx={{ height: 'fit-content' }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <UserAvatar imageSrc={conversation.currentAgent?.image} large />
      </Badge>
      <Stack gap={2}>
        <Stack>
          <Typography variant="body2" fontWeight="bold">
            Hooray! {conversation.currentAgent.firstName} accepted.
          </Typography>
          <Typography variant="body2" color="textSecondary">
            The chat with {conversation.conversationStarter.firstName} has been
            successfully transferred.
          </Typography>
        </Stack>
        <Button
          size="small"
          variant="outlined"
          onClick={(e) => {
            e.stopPropagation();
            onClose();
            setIsVisible(false);
          }}
        >
          Close
        </Button>
      </Stack>
    </RootTransferCard>
  );
};
